export default function SyncRiskTypeDialogController(
  $q,
  $rootScope,
  $scope,
  ssDialogService,
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.showingImage = false;
  vm.showingHtml = false;

  /** ************************************************
   * Event Handlers
   */
  activate();

  function activate() {
    if (vm.imageData) {
      vm.showingImage = true;
    } else {
      vm.showingHtml = true;
    }
  }

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.home.dashBoardDetailDialog);
  }
}

SyncRiskTypeDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'ssDialogService',
];
